// Hindi: navigation menu, account chrome and role labels (field-facing screens). Keyed by the English source text.
export default {
  "Account": "खाता",
  "Account menu": "खाता मेनू",
  "Accounting": "लेखांकन",
  "Administration": "प्रशासन",
  "Assets": "एसेट",
  "Assets & Inventory": "एसेट और इन्वेंटरी",
  "Audit Scan": "ऑडिट स्कैन",
  "Audit Schedules": "ऑडिट शेड्यूल",
  "Audits": "ऑडिट",
  "Blind Counts": "ब्लाइंड गिनती",
  "Blind Counts & Variance": "ब्लाइंड गिनती और अंतर",
  "Close": "बंद करें",
  "Coming in Phase 2": "चरण 2 में आएगा",
  "Custody": "अभिरक्षा",
  "Custody & Movements": "अभिरक्षा और स्थानांतरण",
  "Dashboard": "डैशबोर्ड",
  "Depreciation": "मूल्यह्रास",
  "Depreciation Runs": "मूल्यह्रास रन",
  "Directory": "निर्देशिका",
  "Disposals": "निपटान",
  "Disposals & Write-Offs": "निपटान और बट्टे खाते",
  "Home": "होम",
  "Incident Logging": "घटना दर्ज करना",
  "Incidents": "घटनाएँ",
  "Integrations": "इंटीग्रेशन",
  "Interface language": "इंटरफ़ेस भाषा",
  "Inwarding": "आवक",
  "Inwarding & Tagging": "आवक और टैगिंग",
  "Language": "भाषा",
  "Locations": "स्थान",
  "Locations & Hierarchy": "स्थान और पदानुक्रम",
  "Log In": "लॉग इन करें",
  "Log in": "लॉग इन करें",
  "Maintenance": "रखरखाव",
  "Master Item Catalogue": "मास्टर आइटम कैटलॉग",
  "More": "और",
  "Orders": "ऑर्डर",
  "Physical Verification": "भौतिक सत्यापन",
  "Plans": "प्लान",
  "Plans & Billing": "प्लान और बिलिंग",
  "Properties": "प्रॉपर्टी",
  "Reconcile": "मिलान",
  "Reconciliation Console": "मिलान कंसोल",
  "Review billing": "बिलिंग देखें",
  "Roles & Permissions": "भूमिकाएँ और अनुमतियाँ",
  "Room Kit Stamping": "रूम किट स्टैम्पिंग",
  "Room Kits": "रूम किट",
  "Scan": "स्कैन",
  "Schedules": "शेड्यूल",
  "Security": "सुरक्षा",
  "Sign Out": "साइन आउट",
  "Sign out": "साइन आउट",
  "Toggle navigation": "नेविगेशन दिखाएँ/छिपाएँ",
  "User Directory": "उपयोगकर्ता निर्देशिका",
  "Work Orders": "वर्क ऑर्डर",
  "Admin": "एडमिन",
  "Customer Admin": "ग्राहक एडमिन",
  "Property Manager": "प्रॉपर्टी मैनेजर",
  "Finance Controller": "वित्त नियंत्रक",
  "Auditor (read-only)": "ऑडिटर (केवल देखें)",
  "Field User": "फ़ील्ड उपयोगकर्ता",
  "Storekeeper": "स्टोरकीपर",
  "Department Head": "विभाग प्रमुख",
  "User": "उपयोगकर्ता",
};
